import * as React from 'react';
import { FC } from 'react';

import { useSupportData } from 'features/support/core/hooks/use-support-data';

import DrawerPage from 'components/layout/drawer-page';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';

import { ErrorView } from '../error-view';
import { LoadingView } from '../loading-view';

import { SupportV2CategoriesView } from './support-v2-categories-view';

/**
 * Displays list of support category groups as links to their individual pages.
 */
const SupportV2CategoriesPage: FC<React.PropsWithChildren<unknown>> = () => {
  const { supportCategoryGroups, isSupportDataLoading } = useSupportData();

  const pageTitleText = t('supportTopics');
  const sectionTitle = t('whatDoYouNeedHelpWith');

  if (isSupportDataLoading) {
    return <LoadingView />;
  }

  if (!supportCategoryGroups || supportCategoryGroups.length === 0) {
    return <ErrorView message={t('looksLikeWereExperiencingIssues')} />;
  }

  const categoryGroups = supportCategoryGroups.map(group => ({
    _id: group?._id || '',
    name: group?.name?.locale ?? '',
  }));

  return (
    <DrawerPage headerText={pageTitleText}>
      <Typography pt="$4" variant="headerTwo" style={{ alignSelf: 'center' }}>
        {sectionTitle}
      </Typography>
      <SupportV2CategoriesView categoryGroups={categoryGroups} />
    </DrawerPage>
  );
};

export default SupportV2CategoriesPage;
